export const PRODUCT = {
    SORT_ORDER_TYPE: {
        NEW: 1,
        HOT: 2,
        PRICE_LOW: 3,
        PRICE_HIGHT: 4,
    },
};
